<template>
  <div :class="isImage && 'chat-media-container'">
    <LightBox v-if="isImage">
      <a :href="message.attachment.url" class="chat-img-container">
        <img class="chat-img" :src="message.attachment.url" />
      </a>
    </LightBox>
    <a
      v-else
      :href="message.attachment.url"
      :download="message.attachment.name || true"
      :style="{ textDecoration: 'none' }"
    >
      <div class="chat-msg">
        <strong>⬇️ Download:</strong><br />
        <span class="chat-msg-attachment-file-name">
          {{ message.attachment.name }}
        </span>
      </div>
    </a>
  </div>
</template>

<script lang="ts">
import { MediaMessage } from '@/common/bot/types/messages/MediaMessage';
import LightBox from '@/components/Lightbox/LightBox.vue';
import { Component, Prop, Vue } from 'vue-property-decorator';

// TODO: Refactor Me Later
@Component({ components: { LightBox } })
export default class ChatMedia extends Vue {
  @Prop({ default: () => ({}) }) message!: MediaMessage;
  get isImage() {
    return /^image/.test(this.message.attachment.mimeType);
  }
}
</script>
